if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      try {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach(function(mediaToSwitch) {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        }.bind(this));

        if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) {
          this.removeListSemantic();
        }

        // Get all media items
        this.allMediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        
        // Filter to only image items
        this.mediaItems = this.allMediaItems.filter(function(item) {
          var img = item.querySelector('img');
          return img !== null;
        });
        
        if (this.mediaItems.length === 0) {
          this.mediaItems = this.allMediaItems;
        }
        
        // Find current index
        this.currentIndex = 0;
        var activeMedia = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (activeMedia) {
          var foundIndex = this.mediaItems.findIndex(function(item) {
            return item.dataset.mediaId === activeMedia.dataset.mediaId;
          });
          if (foundIndex !== -1) {
            this.currentIndex = foundIndex;
          }
        }

        // Setup arrow buttons
        this.setupArrowButtons();
      } catch(e) {
        return;
      }
    }

    setupArrowButtons() {
      try {
        var prevButton = this.querySelector('.gallery-arrow-prev');
        var nextButton = this.querySelector('.gallery-arrow-next');

        if (prevButton) {
          prevButton.addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            this.goToPrevImage();
          }.bind(this));
        }

        if (nextButton) {
          nextButton.addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            this.goToNextImage();
          }.bind(this));
        }
      } catch(e) {
        return;
      }
    }

    getNextValidIndex(currentIndex) {
      var nextIndex = currentIndex + 1;
      if (nextIndex >= this.mediaItems.length) {
        nextIndex = 0;
      }
      return nextIndex;
    }

    getPrevValidIndex(currentIndex) {
      var prevIndex = currentIndex - 1;
      if (prevIndex < 0) {
        prevIndex = this.mediaItems.length - 1;
      }
      return prevIndex;
    }

    goToNextImage() {
      try {
        var nextIndex = this.getNextValidIndex(this.currentIndex);
        
        if (nextIndex === this.currentIndex) {
          for (var i = 0; i < this.mediaItems.length; i++) {
            var img = this.mediaItems[i].querySelector('img');
            if (img) {
              nextIndex = i;
              break;
            }
          }
        }
        
        // Use Shopify's native method to change media
        var mediaId = this.mediaItems[nextIndex].dataset.mediaId;
        this.setActiveMedia(mediaId, false);
        this.currentIndex = nextIndex;
      } catch(e) {
        return;
      }
    }

    goToPrevImage() {
      try {
        var prevIndex = this.getPrevValidIndex(this.currentIndex);
        
        if (prevIndex === this.currentIndex) {
          for (var i = this.mediaItems.length - 1; i >= 0; i--) {
            var img = this.mediaItems[i].querySelector('img');
            if (img) {
              prevIndex = i;
              break;
            }
          }
        }
        
        // Use Shopify's native method to change media
        var mediaId = this.mediaItems[prevIndex].dataset.mediaId;
        this.setActiveMedia(mediaId, false);
        this.currentIndex = prevIndex;
      } catch(e) {
        return;
      }
    }

    onSlideChanged(event) {
      try {
        var mediaId = event.detail.currentElement.dataset.mediaId;
        var thumbnail = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
        this.setActiveThumbnail(thumbnail);
        
        var newIndex = this.mediaItems.findIndex(function(item) {
          return item.dataset.mediaId === mediaId;
        });
        if (newIndex !== -1) {
          this.currentIndex = newIndex;
        }
      } catch(e) {
        return;
      }
    }

    setActiveMedia(mediaId, prepend) {
      try {
        var activeMedia = this.elements.viewer.querySelector('[data-media-id="' + mediaId + '"]');
        
        if (!activeMedia) return;
        
        // Update currentIndex
        var newIndex = this.mediaItems.findIndex(function(item) {
          return item.dataset.mediaId === mediaId;
        });
        if (newIndex !== -1) {
          this.currentIndex = newIndex;
        }
        
        // Use Shopify's native method - just toggle classes, don't manipulate display
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function(element) {
          element.classList.remove('is-active');
        });
        
        activeMedia.classList.add('is-active');
        
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            var activeThumbnail = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }
          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();
        
        if (activeMedia) {
          this.playActiveMedia(activeMedia);
        }

        if (!this.elements.thumbnails) return;
        var activeThumbnail = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      } catch(e) {
        return;
      }
    }

    setActiveThumbnail(thumbnail) {
      try {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach(function(element) {
          element.removeAttribute('aria-current');
        });
        var button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', true);
        }
        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          return;
        }
        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      } catch(e) {
        return;
      }
    }

    announceLiveRegion(activeItem, position) {
      try {
        if (!activeItem) return;
        var image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = function() {
          if (this.elements.liveRegion) {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(function() {
              if (this.elements.liveRegion) {
                this.elements.liveRegion.setAttribute('aria-hidden', true);
              }
            }.bind(this), 2000);
          }
        }.bind(this);
        if (image.src) {
          image.src = image.src;
        }
      } catch(e) {
        return;
      }
    }

    playActiveMedia(activeItem) {
      try {
        if (!activeItem) return;
        window.pauseAllMedia();
        var deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      } catch(e) {
        return;
      }
    }

    preventStickyHeader() {
      try {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      } catch(e) {
        return;
      }
    }

    removeListSemantic() {
      try {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(function(slide) {
          slide.setAttribute('role', 'presentation');
        });
      } catch(e) {
        return;
      }
    }
  });
}